module.exports = __webpack_public_path__ + "ico_Analisis_Cx.png";